module.exports = __webpack_public_path__ + "img/kominfo.316a7486.png";